import { render, staticRenderFns } from "./route.vue?vue&type=template&id=c0af7f0a&scoped=true&"
import script from "./route.vue?vue&type=script&lang=js&"
export * from "./route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af7f0a",
  null
  
)

export default component.exports